import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { VkPollAnswer } from '@shared/models/vk';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-vk-poll',
  templateUrl: './vk-poll.component.html',
  styleUrls: ['./vk-poll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VkPollComponent {
  @Input() public answers: VkPollAnswer[];

  @Input()
  @HostBinding('class.finished')
  public isFinished = false;

  public icons = CustomIcons;
}
